<template>
  <div class="wrapper t_info">
    <parallax class="page-header header-filter"></parallax>
    <div class="main">
      <div class="section t_step">
        <div class="md-layout-item md-size-90 md-small-size-100 mx-auto">
          <md-card class="t_detail" id="printMe">
            <h3>
              <md-icon>local_printshop</md-icon> Custome Guest Room Order Detail
              <span class="subhealine pull-right"><img :src="daysinnLogoUrl" style="width:80px" alt="Days Inn Sherman"></span>
            </h3>
            <md-divider></md-divider>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <p>Payment received Date: {{resData.date}}</p>
              </div>
              <div class="md-layout-item">
                <p>Invoice ID: {{resData.orderId}}
                </p>
              </div>
              <div class="md-layout-item">
                <p>Gross amount:</p>
                <h4>$ {{resData.total}}
                </h4>
              </div>
            </div>
            <md-table class="text-left" md-card>
              <md-table-row>
                <md-table-head>Order Detail</md-table-head>
                <md-table-head>Name</md-table-head>
                <md-table-head>Email</md-table-head>
                <md-table-head>Quantity</md-table-head>
                <md-table-head>Price</md-table-head>
                <md-table-head>Tax</md-table-head>
                <md-table-head>Purchase Total</md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell md-label="Order Detail">{{resData.name}}</md-table-cell>
                <md-table-cell md-label="Name">{{resData.customer}}</md-table-cell>
                <md-table-cell md-label="Email">{{resData.email}}</md-table-cell>
                <md-table-cell md-label="Quantity">{{resData.count}}</md-table-cell>
                <md-table-cell md-label="Price">$ {{resData.price}}</md-table-cell>
                <md-table-cell md-label="Tax">$ {{resData.tax}}</md-table-cell>
                <md-table-cell md-label="Purchase Total">$ {{resData.total}}</md-table-cell>
              </md-table-row>

            </md-table>
            <p>Customer Requirement: Check In Date: {{resData.startDate.substring(0, 10)}} | Check Out Date: {{resData.endDate.substring(0, 10)}} | Adult: {{resData.adult}} | Children: {{resData.children}} </p>
            <p>Attention:</p>
            <md-button
              @click="print"
              class="md-orange md-sm pull-right"
              ><md-icon>local_printshop</md-icon> PRINT OUT
            </md-button>
          </md-card>
        </div> 
      </div>    
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data: () => {
      return {
        daysinnLogoUrl: require("@/assets/img/daysinnLogo.png"),
        output: null,
        type:'',
        orderId: '',
        myresult: [],
        resData: {
          type: '',
          name: '',
          price: 0,
          count: 1,
          date: '',
          orderId: '',
          customer: '',
          email: '',
          phone: '',
          tax: 0,
          total: 0,
          startDate: '',
          endDate: '',
          adult: 0,
          children: 0
        }
      }
    },
    props: {
      
    },
    computed: {
    },
    methods: {
      setData: function () {
        let that = this
        let data = JSON.stringify({"type":this.type,"orderId":this.orderId});
        // axios.post('/cgi-bin/php/getHistory.php', data).then((res) => {
        axios.post('https://www.orangetreetx.com/cgi-bin/php/getHistory.php', data).then((res) => {
          console.log(res.data)
          if(res.status === 200) {
            that.myresult = res.data.result
          } else {
           
          }
          // return that.myresult
        }).catch((error) => {
          console.log(error)
        }).finally((res) => {
          that.resData.orderId = that.myresult[0].invoiceId
          that.resData.type = that.myresult[0].typeName
          that.resData.name = that.myresult[0].roomName
          that.resData.date = that.myresult[0].date
          that.resData.price = that.myresult[0].paymentGross
          that.resData.tax = that.myresult[0].tax
          that.resData.total = that.myresult[0].payments
          that.resData.customer = that.myresult[0].userName
          that.resData.email = that.myresult[0].email
          that.resData.startDate = that.myresult[0].checkInDate
          that.resData.endDate = that.myresult[0].checkOutDate
          that.resData.adult = that.myresult[0].adult
          that.resData.children = that.myresult[0].children
        })
      },
      print() {
      // Pass the element id here
        // this.$htmlToPaper('printMe');
    
var printHtml = document.getElementById('printMe').innerHTML;

window.print(printHtml);
return false; 
      },
      getData: function () {
        this.type = this.$route.params.type
        this.orderId = this.$route.params.orderId
      },
    },
    created () {
      let that = this
      that.getData()
      that.setData()
    },
    beforeMount() {
      
    },
    mounted() {
      
    }
  }
</script>

<style lang="scss" scoped>
.page-header {
  height: auto;
}
.t_main {
  height: 100%;
  position: relative;
}
.t_content {
  padding-top: 0px;
  .container {
    margin-top: 0px;
    padding: 20px 20px 60px 20px;
  }
}
.t_detail {
  padding: 20px;
}
.md-table-head, .md-table-cell {
  border: 1px solid #0000001f !important;
}
</style>
